import { LazyImage } from '@ui/common/lazy-image.tsx';
import { Button, ButtonGroup, Skeleton } from '@heroui/react';
import { Add, Heart, Minus, Trash } from 'iconsax-react';

export type CartProductProps = {
  image?: string;
  title?: string;
  description?: string;
  price?: string;
  itemPrice?: string;
  count?: string;
  value?: string;
  isFavorite?: boolean;
  onTrashPress?: () => void;
  onFavoritePress?: () => void;
  onMinusPress?: () => void;
  onPlusPress?: () => void;
  isLoading?: boolean;
  isEditable?: boolean;
  trailing?: string;
};

export const CartProduct = ({
  image,
  title = 'Название',
  description = 'Описание',
  price = '1 000 тг',
  value = '1',
  isFavorite,
  onFavoritePress,
  onPlusPress,
  onMinusPress,
  onTrashPress,
  isLoading = false,
  isEditable = false,
  trailing,
}: CartProductProps) => {
  return (
    <div className="flex flex-row gap-x-4">
      <div className="w-[86px] h-[86px] shrink-0 rounded-2xl overflow-hidden">
        <LazyImage src={image} />
      </div>
      <div className="flex-grow">
        <Skeleton isLoaded={!isLoading}>
          <p className="text-[#222222] text-sm text-ellipsis line-clamp-1">
            {title}
          </p>
        </Skeleton>
        <Skeleton isLoaded={!isLoading} className="mt-1.5">
          <p className="text-[#9CA5AC] text-xs text-ellipsis line-clamp-1">
            {description}
          </p>
        </Skeleton>
        <div className="flex flex-row items-center mt-3 justify-between">
          <Skeleton isLoaded={!isLoading}>
            <p className="text-[#222222] text-base font-semibold text-ellipsis line-clamp-1">
              {price}
            </p>
          </Skeleton>

          {trailing && (
            <p className="text-[#9CA5AC] text-sm text-ellipsis line-clamp-1">
              {trailing}
            </p>
          )}
        </div>

        {isEditable && (
          <div className="flex flex-row items-center justify-between mt-4">
            <ButtonGroup>
              <Button
                disabled={isLoading}
                size="sm"
                className="bg-[#F5F5F5]"
                disableAnimation
                isIconOnly
                radius="full"
                onPress={onMinusPress}
              >
                <Minus
                  className="select-none border-none outline-none"
                  color="#222222"
                  size="16"
                  variant="Outline"
                />
              </Button>
              <Button
                size="sm"
                className="bg-[#F5F5F5] text-[#222222]"
                disableAnimation
                isIconOnly
                radius="full"
              >
                {value}
              </Button>
              <Button
                size="sm"
                disabled={isLoading}
                className="bg-[#F5F5F5]"
                disableAnimation
                isIconOnly
                radius="full"
                onPress={onPlusPress}
              >
                <Add
                  className="select-none border-none outline-none"
                  color="#222222"
                  size="16"
                  variant="Outline"
                />
              </Button>
            </ButtonGroup>

            <div className="flex flex-row items-center gap-x-6">
              <Button
                size="sm"
                isIconOnly
                radius="full"
                variant="light"
                disabled={isLoading}
                onPress={onFavoritePress}
              >
                {!isFavorite && (
                  <Heart
                    className="select-none border-none outline-none"
                    color="#222222"
                    size="24"
                    variant="Outline"
                  />
                )}
                {isFavorite && (
                  <Heart
                    className="select-none border-none outline-none"
                    color="#F53639"
                    size="26"
                    variant="Bold"
                  />
                )}
              </Button>

              <Button
                size="sm"
                isIconOnly
                radius="full"
                variant="light"
                onPress={onTrashPress}
                disabled={isLoading}
              >
                <Trash
                  className="select-none border-none outline-none"
                  color="#222222"
                  size="24"
                  variant="Outline"
                />
              </Button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
